import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { DoctorService } from '../../services/doctor.service';
import { Router } from '@angular/router';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { Meta } from '@angular/platform-browser';
@Component({
  selector: 'app-pulsemain',
  templateUrl: './pulsemain.component.html',
  styleUrls: ['./pulsemain.component.css']
})
export class PulsemainComponent implements OnInit {
  loading: any;
  blog: any;
  chatlength:any;
  onlinelength:any;
  applength:any;
  doclength:any;
  constructor(private commonService: CommonService, private doctorService: DoctorService,
  private router:Router,  config: NgbCarouselConfig, private meta: Meta) {
    this.commonService.setPulseMenuFlag(1);
    config.interval = 5000;
    config.wrap = true;
    config.keyboard = true;
   // this.commonService.pulsemenuflagstatus.next(0);
   const title = this.meta.getTag('name=title');
   this.meta.removeTagElement(title); 
   const description = this.meta.getTag('name=description');
   this.meta.removeTagElement(description);
   this.meta.addTag({ name: 'title', content: 'Online Veterinary Consultation for Pets | Ask a Vet Online | Petcart' });
   this.meta.addTag({ name: 'description', content: 'Veterinarians near me - Booking Appointments with Vets, Follow-ups, Storing Records, Vaccination Reminders & Expert advice' });
   }

  ngOnInit() {
    this.getRecentBlogs();
    this.getServiceprovider();
  }
  getRecentBlogs() {
    this.loading = true;
    this.doctorService.getRecentBlogs()
    .subscribe(
    (x) => {
      this.loading = false;
      this.blog = x;
      this.eliminate();
    });
   }
  eliminate() {
    let i = this.blog.length - 1;
    while (i > 2 ) {
        this.blog.splice(i, 1);
        i --;
      }
  }

  setReminder(){
    const flag = 8;
    this.commonService.setActivatepath(flag);
    this.router.navigate(['/pulse/setreminder']);
  }

  goToBlogDetail(id, url) {
    this.router.navigate(['/blogs/detail/' + id, url])
  }
  getServiceprovider() {

    this.doctorService.getDoctors()
    .subscribe((x) => {
      this.doclength = x.length;
      this.getOnlineDoctors();
    });
  }


  getOnlineDoctors() {
    this.doctorService.checkOnlineServiceprovider()
    .subscribe((x) => {
      this.onlinelength = x.length;
      this.getAppointments();
    });
  }
  getAppointments() {
    this.doctorService.getTotalAppointments()
    .subscribe((x) => {
      this.applength = x;
      this.getChats();
    });
  }
  getChats() {
    this.doctorService.getAllChats()
    .subscribe((x) => {
      this.chatlength = x;

    });

  }

}
